import * as React from 'react';
import { Small } from './Small/Small';
import { Medium } from './Medium/Medium';
import { Large } from './Large/Large';
import CircularProgress from '@mui/material/CircularProgress';
import './InfoProceso.css';

function InfoProceso(props) {

    const [caseInfo, setCaseInfo] = React.useState('');
    const [infoLoaded, setInfoLoaded] = React.useState(false);

    React.useEffect(() => {
        fetch(`${props.url}/procesos-api/load-case`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token '+ localStorage.getItem('token'),
            },
            body: JSON.stringify({token: localStorage.getItem('token'),
                                    idProceso: props.idProceso})
        })
        .then(res => res.json())
        .then(json => {
            setCaseInfo(json.caseInfo)
            setInfoLoaded(true)
        })
    }, [props.idProceso, props.url])

    return (
        infoLoaded ?
        <React.Fragment>
            <Small caseInfo={caseInfo} />
            <Medium caseInfo={caseInfo} />
            <Large caseInfo={caseInfo} />
        </React.Fragment> : 
    <CircularProgress />
    );
}

export { InfoProceso };
